var _defs, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentStateScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.38 130.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.19,
    cy: 65.19,
    r: 65.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.35,265.59a1.35,1.35,0,0,0-.26-.15,5.24,5.24,0,0,1-4.05-5.35q0-18.72,0-37.43,0-10.92,0-21.83c0-3.62,2.16-5.78,5.77-5.78,7.89,0,15.78,0,23.67,0a1.18,1.18,0,0,0,1.19-.66,21.49,21.49,0,1,1,21.61,32,21.79,21.79,0,0,1-11.09-1.34c-.79,1.55-2.23,1.6-3.75,1.59-7.17,0-14.34,0-21.52,0a2.93,2.93,0,0,1-3-1.86,2.77,2.77,0,0,1,2.71-3.73c4.15,0,8.31,0,12.47,0h6.59a2.62,2.62,0,0,0-.34-.47,21,21,0,0,1-4.58-6.49c-.22-.5-.54-.54-1-.54q-6.44,0-12.87,0a2.89,2.89,0,0,1-3-1.93,2.76,2.76,0,0,1,2.63-3.66c3.79,0,7.57,0,11.36,0h.87l.29-7.26H233.69v59.21h42.83V259q0-9.12,0-18.24a2.81,2.81,0,0,1,3.69-2.87,2.75,2.75,0,0,1,1.9,2.75q0,9.84,0,19.68a4.2,4.2,0,0,1-.06.87,5.24,5.24,0,0,1-3.68,4.15l-.58.22Zm44.85-44.53a15.89,15.89,0,1,0-15.87-16A15.93,15.93,0,0,0,277.2,221.06Z",
    transform: "translate(-190.42 -162.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.05,252.67c-3.87,0-7.73,0-11.6,0a2.77,2.77,0,0,1-1.2-5.26,3.7,3.7,0,0,1,1.47-.32q11.35,0,22.71,0a2.84,2.84,0,0,1,3,2.42,2.77,2.77,0,0,1-1.86,3,4.26,4.26,0,0,1-1.33.16Z",
    transform: "translate(-190.42 -162.04)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.05,239.58H243.77a2.79,2.79,0,0,1-3-2.14,2.76,2.76,0,0,1,2.21-3.39,6,6,0,0,1,1-.07h22.07a5.19,5.19,0,0,1,1.42.14,2.79,2.79,0,0,1,1.92,2.9,2.76,2.76,0,0,1-2.41,2.5,8.25,8.25,0,0,1-1.11.05Z",
    transform: "translate(-190.42 -162.04)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.15,231.68a8.82,8.82,0,0,1-.13,1.26,2.78,2.78,0,0,1-5.45-.29,7.18,7.18,0,0,1,.05-2.22,2.7,2.7,0,0,1,3-2.19,2.76,2.76,0,0,1,2.52,2.72c0,.24,0,.48,0,.72Z",
    transform: "translate(-190.42 -162.04)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280,198.22c0,1.55,0,3.09,0,4.64a.78.78,0,0,0,.52.84c1.3.62,2.58,1.27,3.86,1.94a2.77,2.77,0,0,1,1.32,3.84,2.72,2.72,0,0,1-3.82,1.17c-1.91-.94-3.8-1.92-5.71-2.87a3,3,0,0,1-1.77-2.87c0-3.68,0-7.36,0-11a2.81,2.81,0,1,1,5.59,0C280,195.34,280,196.78,280,198.22Z",
    transform: "translate(-190.42 -162.04)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentStateScore);
export default __webpack_public_path__ + "static/media/recent_state_score.e342053546ee56ebce58a80b006675a5.svg";
export { ForwardRef as ReactComponent };